import {
  Button,
  HexIcon,
  Icons,
  Placeholder as StatusMessage,
} from '@cast/design-system';

export const ErrorPageGeneric = () => {
  return (
    <StatusMessage
      stackProps={{ mt: 180 }}
      icon={<HexIcon variant="error" icon={<Icons.XCircle weight="fill" />} />}
      title="Service temporarily unavailable"
      titleProps={{ variant: 'h4' }}
      body="We’re working to resolve this issue, service will be up and running soon."
      bodyProps={{ variant: 'P16R' }}
      actions={
        <Button
          startIcon={<Icons.ArrowClockwise />}
          onClick={() => window.location.reload()}
        >
          Refresh page
        </Button>
      }
      testId="error-page"
    />
  );
};
